__turbopack_context__.v({
  "heroImage": "dgyjra_heroImage",
});
